import React, { MouseEvent } from 'react';
import { withContent } from '../../../hoc/withContext';
import './UbisoftPlusBlock.scss';
import { IContent } from '../../../types';
import { getShopURL, sendEvent } from '../../../utils';
import { connect } from 'react-redux';

import Image from '../../UI/Image/Image';

interface IUbisoftPlusBlockProps {
  context?: IContent;
  uplayData?: any;
}

const UbisoftPlusBlock = ({ context, uplayData }: IUbisoftPlusBlockProps) => {
  const { ubisoft_plus } = context;
  const { is_active, flag, title, description, cta, image, legal } = ubisoft_plus;
  const user_subscribed = uplayData['subscription-status'];

  const isUPC = process.env.REACT_APP_ENV === "upc";
  const scopedCta = isUPC && cta.upc ? cta.upc : cta.web;

  return !user_subscribed && is_active && (
    <div className="block-container-ubisoft_plus">
      <div className="bg-desktop">
        <Image
          imageName={image.desktop}
          altText={""}
        />
      </div>
      <div className="bg-tablet">
        <Image
          imageName={image.tablet}
          altText={""}
        />
      </div>
      <div className="bg-mobile">
        <Image
          imageName={image.mobile}
          altText={""}
        />
      </div>
      <div className="block-ubisoft_plus">
        {flag && (
          <div className="flag">{flag}</div>
        )}
        <div className="content">
          <div className="block-title">{title}</div>
          {description && (
            <div className="description" dangerouslySetInnerHTML={{ __html: description}} />
          )}
          {legal && (
            <div className="legal" dangerouslySetInnerHTML={{ __html: legal}} />
          )}
          {scopedCta && scopedCta.link && scopedCta.title && (
            <div className="action">
              <a
                className="ubisoftplus"
                href={getShopURL() + scopedCta.link}
                onClick={() => sendEvent(scopedCta.tracking)}
                data-alt-text={scopedCta.title}
              >
                <span>{scopedCta.title}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  uplayData: state.app.config.uplayData
});

export default connect(mapStateToProps)(withContent(UbisoftPlusBlock));
